import React from "react";

import "./index.css";

export default function Dropdown({
  options = [],
  selectedOption = {},
  onChange = () => {},
}) {
  return (
    <div className="dropdown-container">
      <select onChange={onChange} className="dropdown-select">
        {options.map((option, index) => (
          <option
            key={option.value || index}
            value={index}
            className="dropdown-option"
            selected={option.value === selectedOption.value}
          >
            {option.label || ""}
          </option>
        ))}
      </select>
    </div>
  );
}
